/* THE COURT & CLUB — interaction layer. Zero dependencies, zero apps. */
(function () {
  'use strict';
  var CFG = window.CCLUXE || {};
  var THRESHOLD = parseInt(CFG.freeShip, 10) || 0;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* One source of truth for prices: reuse the shop's own money format so JS
     output is identical to Liquid's `| money`, in any currency. */
  function group(str, thousands, decimal) {
    var parts = String(str).split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return decimal && parts[1] ? int + decimal + parts[1] : int;
  }
  function money(cents) {
    var n = (cents || 0) / 100;
    var fmt = CFG.moneyFormat;
    if (fmt) {
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, key) {
        switch (key) {
          case 'amount_no_decimals': return group(Math.round(n), ',', '');
          case 'amount_with_comma_separator': return group(n.toFixed(2), '.', ',');
          case 'amount_no_decimals_with_comma_separator': return group(Math.round(n), '.', '');
          case 'amount_with_apostrophe_separator': return group(n.toFixed(2), "'", '.');
          case 'amount_with_space_separator': return group(n.toFixed(2), ' ', ',');
          case 'amount_no_decimals_with_space_separator': return group(Math.round(n), ' ', '');
          default: return group(n.toFixed(2), ',', '.');
        }
      });
    }
    try {
      return new Intl.NumberFormat(CFG.locale || 'en-US', {
        style: 'currency', currency: CFG.currency || 'USD'
      }).format(n);
    } catch (e) { return '$' + n.toFixed(2); }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function thumb(url, w) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?|$)/i, '_' + (w || 200) + 'x$1$2');
  }

  /* ---------------- reveal ---------------- */
  function reveal() {
    var els = $$('.rev:not(.in), .craft__c:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------------- header + mobile nav ---------------- */
  function chrome() {
    /* Horizon scrolls .page-wrapper, not the window: document.scrollingElement
       stays at 0 while .page-wrapper.scrollTop climbs. Anything that reads or
       sets scroll position has to go through both. */
    var pw = document.querySelector('.page-wrapper');
    var getY = function () {
      return Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0);
    };
    var toTop = function () {
      if (pw) { try { pw.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { pw.scrollTop = 0; } }
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
    };
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-totop]')) { e.preventDefault(); toTop(); }
    });

    var h = $('.hdr');
    if (h) {
      /* Hide on the way down, return on the way up.
         The transform goes on .hdr itself, NEVER on the section wrapper: an
         ancestor with a transform becomes the containing block for every
         position:fixed descendant, which collapsed the cart drawer, the scrim,
         the search overlay and the mobile nav into the header's 117px box.
         The drawer and overlays are siblings of .hdr, so this is safe. */
      var group = document.querySelector('.shopify-section-group-header-group');
      if (group) group.style.transform = '';
      h.style.transition = 'transform .42s cubic-bezier(.19,1,.22,1)';
      var lastY = getY();
      var hidden = false;
      var on = function () {
        var y = getY();
        h.classList.toggle('stuck', y > 6);

        /* never retract while a modal owns the scroll, or near the top */
        var locked = document.documentElement.style.overflow === 'hidden';
        var down = y > lastY + 4;
        var up = y < lastY - 4;

        if (!locked && down && y > 200 && !hidden) {
          hidden = true;
          h.style.transform = 'translateY(-100%)';
        } else if ((up || y <= 200 || locked) && hidden) {
          hidden = false;
          h.style.transform = 'translateY(0)';
        }
        lastY = y;
      };
      on();
      window.addEventListener('scroll', on, { passive: true });
      if (pw) pw.addEventListener('scroll', on, { passive: true });
    }
    /* Measure the announcement bar so the sticky header wrapper can pull it
       out of view and pin only the nav row. */
    var annEl = $('.ann');
    var setAnn = function () {
      document.documentElement.style.setProperty(
        '--annh', (annEl ? annEl.offsetHeight : 0) + 'px');
    };
    setAnn();
    if (annEl && window.ResizeObserver) new ResizeObserver(setAnn).observe(annEl);
    window.addEventListener('resize', setAnn, { passive: true });

    var ob = $('[data-mopen]'), pn = $('.mnav');
    if (ob && pn) {
      var cb = $('[data-mclose]', pn);
      var t = function (s) {
        pn.classList.toggle('open', s);
        document.documentElement.style.overflow = s ? 'hidden' : '';
        ob.setAttribute('aria-expanded', s ? 'true' : 'false');
      };
      ob.addEventListener('click', function () { t(true); });
      if (cb) cb.addEventListener('click', function () { t(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') t(false); });
    }
  }

  /* ================= CART DRAWER ================= */
  var drawer, scrim, lastFocus;

  function drawerOpen() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('on'); scrim.classList.add('on');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var x = $('.drw__x', drawer); if (x) x.focus();
  }
  function drawerClose() {
    if (!drawer) return;
    drawer.classList.remove('on'); scrim.classList.remove('on');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* The free rate is Standard, never Priority. Saying "free express shipping"
     promised a $19.95 service we do not give away. */
  function fsbHtml(total) {
    if (!THRESHOLD) return '';
    var left = Math.max(THRESHOLD - total, 0);
    var pct = Math.min((total / THRESHOLD) * 100, 100);
    var done = left <= 0;
    var msg = done
      ? '<b>Free shipping unlocked.</b>'
      : 'You are <b>' + money(left) + '</b> from free shipping';
    return '<div class="fsb' + (done ? ' done' : '') + '">' +
      '<p class="fsb__t"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M1 4h13v11H1z"/>' +
      '<path d="M14 8h4l3 3v4h-7z"/><circle cx="5.5" cy="18" r="2"/><circle cx="17.5" cy="18" r="2"/></svg>' +
      '<span>' + msg + '</span></p>' +
      '<div class="fsb__bar"><div class="fsb__f" style="width:' + pct.toFixed(1) + '%"></div></div>' +
      '<div class="fsb__k"><span>' + money(total) + '</span><span>Free at ' + money(THRESHOLD) + '</span></div>' +
      '</div>';
  }

  /* Prices from /recommendations/products.json may arrive as cents or as a
     decimal string depending on the endpoint; normalise before formatting. */
  function cents(p) {
    if (typeof p === 'number') return p;
    var n = parseFloat(p);
    if (isNaN(n)) return 0;
    return String(p).indexOf('.') > -1 ? Math.round(n * 100) : n;
  }

  function itemHtml(it) {
    var saved = (it.original_line_price || 0) - (it.final_line_price || 0);
    return '<article class="li" data-key="' + esc(it.key) + '">' +
      '<a class="li__m" href="' + esc(it.url) + '">' +
        (it.image ? '<img src="' + esc(thumb(it.image, 260)) + '" alt="" loading="lazy">'
                  : '<span class="plate plate--xs"><span class="plate__m">C&amp;C</span></span>') +
      '</a>' +
      '<div class="li__b">' +
        '<div class="li__top">' +
          '<a class="li__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          '<button type="button" class="li__x" data-rm aria-label="Remove ' + esc(it.product_title) + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>' +
          '</button>' +
        '</div>' +
        (it.variant_title && it.variant_title !== 'Default Title'
          ? '<span class="li__v">' + esc(it.variant_title) + '</span>' : '') +
        '<div class="li__r">' +
          '<span class="qty">' +
            '<button type="button" data-dec aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-inc aria-label="Increase quantity">+</button>' +
          '</span>' +
          '<span class="li__p">' + money(it.final_line_price) +
            (saved > 0 ? '<s>' + money(it.original_line_price) + '</s>' : '') +
          '</span>' +
        '</div>' +
      '</div>' +
      '<div class="li__rec" data-rec="' + it.product_id + '"></div>' +
    '</article>';
  }

  /* Per-line-item recommendations. Shopify generates these natively, so this
     needs no app — and it beats one generic rail because the suggestion is
     tied to the item the shopper actually chose. */
  function recs(cart) {
    var owned = cart.items.map(function (i) { return i.product_id; });
    $$('[data-rec]', drawer).forEach(function (host) {
      if (host.dataset.done) return;
      host.dataset.done = '1';
      var pid = host.getAttribute('data-rec');
      fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=related',
        { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var picks = (d.products || []).filter(function (pr) {
            return pr.available && owned.indexOf(pr.id) === -1;
          }).slice(0, 2);
          if (!picks.length) return;
          host.innerHTML = '<p class="li__rh">' + (CFG.recTitle || 'Goes with this') + '</p>' +
            picks.map(function (pr) {
              var pv = null;
              for (var i = 0; i < pr.variants.length; i++) {
                if (pr.variants[i].available) { pv = pr.variants[i]; break; }
              }
              if (!pv) pv = pr.variants[0];
              var one = pr.variants.length === 1;
              return '<div class="rec">' +
                '<a class="rec__m" href="' + esc(pr.url) + '">' +
                  (pr.featured_image
                    ? '<img src="' + esc(thumb(pr.featured_image, 120)) + '" alt="" loading="lazy">'
                    : '<span class="plate plate--xs"><span class="plate__m">C&amp;C</span></span>') +
                '</a>' +
                '<span class="rec__b">' +
                  '<a href="' + esc(pr.url) + '">' + esc(pr.title) + '</a>' +
                  '<em>' + money(cents(pv.price)) + '</em>' +
                '</span>' +
                (one
                  ? '<button type="button" class="rec__add" data-add="' + pv.id + '" aria-label="Add ' + esc(pr.title) + '">+</button>'
                  : '<a class="rec__add" href="' + esc(pr.url) + '" aria-label="Choose options for ' + esc(pr.title) + '">+</a>') +
              '</div>';
            }).join('');
        })
        .catch(function () { });
    });
  }

  function paint(cart) {
    if (!drawer) return;
    var scroll = $('[data-drw-scroll]', drawer);
    var foot = $('[data-drw-foot]', drawer);
    var ups = $('[data-ups]', drawer);

    $$('[data-cart-count]').forEach(function (b) {
      b.textContent = cart.item_count;
      b.style.display = cart.item_count > 0 ? '' : 'none';
    });

    if (!cart.item_count) {
      scroll.innerHTML =
        '<div class="drw__empty">' +
          '<span class="drw__eb"><svg viewBox="0 0 24 24" aria-hidden="true">' +
            '<path d="M6 8h12l-1 12H7z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg></span>' +
          '<p class="d3">Your bag is empty</p>' +
          '<p class="body">Nothing chosen yet. The Court Collection is the place to start.</p>' +
          '<a class="btn btn--ghost" href="/collections/court-collection">Start with the collection</a>' +
        '</div>';
      if (foot) foot.hidden = true;
    } else {
      var html = fsbHtml(cart.total_price);
      cart.items.forEach(function (it) { html += itemHtml(it); });
      scroll.innerHTML = html;

      if (foot) {
        foot.hidden = false;
        var st = $('[data-subtotal]', foot);
        if (st) st.textContent = money(cart.total_price);

        /* Total saved across the bag — a real number, straight from Shopify. */
        var saved = 0;
        cart.items.forEach(function (it) {
          saved += (it.original_line_price || 0) - (it.final_line_price || 0);
        });
        var sv = $('[data-saved]', foot);
        if (sv) {
          sv.hidden = saved <= 0;
          if (saved > 0) sv.innerHTML = 'You are saving <b>' + money(saved) + '</b>';
        }
      }
      recs(cart);
    }

    /* the server-rendered rail lives outside the scroll area so it survives repaints */
    if (ups) {
      var host = $('[data-ups-host]', drawer);
      if (host && ups.parentElement !== host) host.appendChild(ups);
      ups.hidden = cart.item_count > 0;
    }

    var note = $('[data-note]', drawer);
    if (note && note.value === '' && cart.note) note.value = cart.note;
  }

  function fetchCart(then) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paint(c); if (then) then(c); return c; })
      .catch(function () { });
  }

  function addToCart(id, qty, btn) {
    if (btn) { btn.dataset.label = btn.textContent; btn.innerHTML = '<span class="spin"></span>'; btn.disabled = true; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = res.ok ? 'Added' : (res.d.description || 'Unavailable'); }
        if (res.ok) { fetchCart(); drawerOpen(); }
        if (btn) setTimeout(function () { btn.textContent = btn.dataset.label || 'Add'; }, 1600);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add'; } });
  }

  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(paint).catch(function () { });
  }

  function cart() {
    drawer = $('[data-drawer]');
    scrim = $('[data-scrim]');
    if (!drawer || !scrim) return;

    scrim.addEventListener('click', drawerClose);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawerClose(); });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('.drw__x')) drawerClose();
    });

    /* open drawer instead of navigating to /cart */
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cart-open], a[href$="/cart"], a[href*="/cart?"]');
      if (t) { e.preventDefault(); drawerOpen(); fetchCart(); }
    });

    /* intercept every add-to-cart form */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      var fd = new FormData(f);
      var btn = f.querySelector('[type="submit"]');
      if (btn) { btn.dataset.label = btn.textContent.trim(); btn.innerHTML = '<span class="spin"></span>'; btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (btn) {
            btn.disabled = false;
            btn.textContent = res.ok ? 'Added to bag' : (res.d.description || 'Unavailable');
            setTimeout(function () { btn.textContent = btn.dataset.label || 'Add to bag'; }, 1800);
          }
          if (res.ok) { fetchCart(); drawerOpen(); }
        })
        .catch(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; } });
    });

    /* quick add + upsell add */
    document.addEventListener('click', function (e) {
      var q = e.target.closest('[data-add]');
      if (!q) return;
      e.preventDefault();
      addToCart(q.getAttribute('data-add'), 1, q);
    });

    /* line item controls */
    drawer.addEventListener('click', function (e) {
      var row = e.target.closest('.li'); if (!row) return;
      var key = row.getAttribute('data-key');
      var n = parseInt(($('.qty span', row) || {}).textContent, 10) || 1;
      if (e.target.closest('[data-inc]')) change(key, n + 1);
      else if (e.target.closest('[data-dec]')) change(key, Math.max(n - 1, 0));
      else if (e.target.closest('[data-rm]')) change(key, 0);
    });

    /* gift / order note */
    var noteBox = $('[data-note]', drawer);
    if (noteBox) {
      var saveNote = function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: noteBox.value })
        }).catch(function () { });
      };
      var nt;
      noteBox.addEventListener('input', function () { clearTimeout(nt); nt = setTimeout(saveNote, 600); });
      noteBox.addEventListener('blur', saveNote);
    }

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drw-continue]')) drawerClose();
    });

    fetchCart();
    if (/^\/cart/.test(location.pathname)) setTimeout(function () { drawerOpen(); }, 260);
  }

  /* ================= PREDICTIVE SEARCH ================= */
  function search() {
    var panel = $('[data-srch]');
    if (!panel) return;
    var input = $('[data-srch-i]', panel);
    var out = $('[data-srch-r]', panel);
    var last = null;

    function open() {
      panel.classList.add('on');
      panel.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { input.focus(); }, 120);
    }
    function close() {
      panel.classList.remove('on');
      panel.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-srch-open]')) { e.preventDefault(); open(); }
      else if (e.target.closest('[data-srch-close]')) close();
      else if (e.target === panel) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('on')) close();
    });

    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(function () {
        if (q === last) return;
        last = q;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',
          { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = ((d.resources || {}).results || {}).products || [];
            if (!items.length) {
              out.innerHTML = '<p class="srch__none">Nothing matches &ldquo;' + esc(q) + '&rdquo;.</p>';
              return;
            }
            out.innerHTML = '<div class="srch__g">' + items.map(function (pr) {
              return '<a class="srch__c" href="' + esc(pr.url) + '">' +
                '<span class="srch__m">' +
                  (pr.featured_image && pr.featured_image.url
                    ? '<img src="' + esc(thumb(pr.featured_image.url, 200)) + '" alt="" loading="lazy">'
                    : '<span class="plate plate--xs"><span class="plate__m">C&amp;C</span></span>') +
                '</span>' +
                '<span class="srch__t">' + esc(pr.title) + '</span>' +
                '<span class="srch__p">' + money(cents(pr.price)) + '</span>' +
              '</a>';
            }).join('') + '</div>' +
            '<a class="link srch__all" href="/search?q=' + encodeURIComponent(q) + '">See all results</a>';
          })
          .catch(function () { });
      }, 220);
    });
  }

  /* ================= PDP ================= */
  function pdp() {
    var root = $('[data-pdp]'); if (!root) return;
    var data = $('[data-variants]', root); if (!data) return;
    var vs; try { vs = JSON.parse(data.textContent); } catch (e) { return; }

    var form = $('[data-form]', root),
        vid = $('[data-vid]', root),
        now = $('[data-now]', root),
        was = $('[data-was]', root),
        sav = $('[data-save]', root),
        btn = $('[data-add-main]', root),
        sp = $('[data-sticky-price]');

    function sel() {
      return $$('[data-opt]', root).map(function (g) {
        var c = $('input:checked', g); return c ? c.value : null;
      });
    }
    function match(s) {
      return vs.find(function (v) { return s.every(function (x, i) { return x === null || v.options[i] === x; }); });
    }
    function render() {
      var v = match(sel()); if (!v) return;
      if (vid) vid.value = v.id;
      if (now) now.textContent = money(v.price);
      if (sp) sp.textContent = money(v.price);
      var on = v.compare_at_price && v.compare_at_price > v.price;
      if (was) { was.hidden = !on; if (on) was.textContent = money(v.compare_at_price); }
      if (sav) {
        sav.hidden = !on;
        if (on) sav.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? (btn.dataset.labelAdd || 'Add to bag') : 'Sold out';
      }
      $$('[data-opt]', root).forEach(function (g) {
        var lab = $('[data-optval]', g), c = $('input:checked', g);
        if (lab && c) lab.textContent = c.value;
      });
      if (history.replaceState) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      }
    }
    root.addEventListener('change', function (e) { if (e.target.matches('[data-opt] input')) render(); });
    render();

    var sb = $('.sbar');
    if (sb && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        sb.classList.toggle('in', !en[0].isIntersecting);
      }, { rootMargin: '-140px 0px 0px 0px' }).observe(form);
    }
    var jump = $('[data-jump]');
    if (jump && form) jump.addEventListener('click', function (ev) {
      ev.preventDefault(); form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ================= SHOP THE LOOK ================= */
  function hotspots() {
    $$('[data-stl]').forEach(function (root) {
      var pins = $$('.hs', root), rows = $$('.stl__row', root);
      function focus(i) {
        pins.forEach(function (p, n) { p.setAttribute('aria-expanded', n === i ? 'true' : 'false'); });
        rows.forEach(function (r, n) { r.classList.toggle('on', n === i); });
        if (rows[i]) rows[i].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      pins.forEach(function (p, i) {
        p.addEventListener('click', function () { focus(i); });
        p.addEventListener('mouseenter', function () { focus(i); });
      });
      rows.forEach(function (r, i) { r.addEventListener('mouseenter', function () { focus(i); }); });
    });
  }

  /* ================= LIGHTBOX ================= */
  /* Class-driven, never [hidden]-driven: an author `display` rule silently beats
     the UA [hidden] rule, which previously left this overlay covering every PDP. */
  function lightbox() {
    var imgs = $$('[data-zoom] img');
    if (!imgs.length) return;

    var box = document.createElement('div');
    box.className = 'lb' + (imgs.length < 2 ? ' lb--solo' : '');
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Product image');
    box.innerHTML =
      '<button class="lb__x" type="button" aria-label="Close image">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
      '<button class="lb__a lb__a--p" type="button" aria-label="Previous image">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4l-8 8 8 8"/></svg></button>' +
      '<figure class="lb__f"><img alt=""></figure>' +
      '<button class="lb__a lb__a--n" type="button" aria-label="Next image">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4l8 8-8 8"/></svg></button>' +
      '<p class="lb__n"><span></span></p>';
    document.body.appendChild(box);

    var big = box.querySelector('img');
    var num = box.querySelector('.lb__n span');
    var idx = 0;
    var isOpen = false;
    var lastFocused = null;

    function show(i) {
      idx = (i + imgs.length) % imgs.length;
      var im = imgs[idx];
      big.src = im.currentSrc || im.src;
      big.alt = im.alt || '';
      if (num) num.textContent = (idx + 1) + ' / ' + imgs.length;
    }
    function openAt(i) {
      lastFocused = document.activeElement;
      show(i);
      isOpen = true;
      box.classList.add('on');
      document.documentElement.style.overflow = 'hidden';
      box.querySelector('.lb__x').focus();
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      box.classList.remove('on');
      document.documentElement.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    box.addEventListener('click', function (e) {
      if (e.target.closest('.lb__a--p')) { e.stopPropagation(); show(idx - 1); return; }
      if (e.target.closest('.lb__a--n')) { e.stopPropagation(); show(idx + 1); return; }
      close();
    });
    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });
    imgs.forEach(function (im, i) {
      var host = im.parentElement;
      if (!host) return;
      host.addEventListener('click', function () { openAt(i); });
    });
  }

  function boot() {
    /* Safety: never inherit a stuck scroll lock from a previous render or a
       handler that threw between open and close. */
    document.documentElement.style.overflow = '';
    reveal(); chrome(); cart(); search(); pdp(); hotspots(); lightbox();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
